import { FunctionComponent } from "react";
import Button from "../Button/Button";
import ListItem from "../ListItem/ListItem";
import { Heading } from "../Text/Heading";

export interface OptionBoxProps {
  onSelect: Function;
  id: string;
  index: number;
  questionId: string;
  heading: string;
  description: string;
  icon: string;
  iconLabel: string;
  label: string;
  note: string;
  cta: string;
  primary?: boolean;
  value: number;
  fullWidth?: boolean;
  list: [
    {
      id: string;
      icon: string;
      label: string;
    }
  ];
  isLoading?: boolean;
}

const OptionBox: FunctionComponent<OptionBoxProps> = ({
  cta,
  id,
  questionId,
  icon,
  iconLabel,
  heading,
  label,
  note,
  fullWidth,
  value,
  description,
  primary,
  children,
  onSelect,
  isLoading,
}) => {
  const borderClass = primary ? "border-primary" : "border-gray-300";
  return (
    <div
      className={
        `flex flex-col p-6 lg:p-8 border rounded-single-choice ${
          !fullWidth ? "lg:max-w-sm" : ""
        } h-full w-full text-left ` + borderClass
      }
    >
      <div className="flex mb-2 items-center">
        {icon ? <img src={icon} className="mr-3" /> : null}
        <p>{iconLabel}</p>
      </div>
      <Heading level={3} className="mb-4">
        {heading}
      </Heading>
      <p className="mb-8">{description}</p>
      <ul className="mb-12 ">{children}</ul>
      <div className="flex items-end h-full justify-self-end">
        <Heading level={2} className="text-3xl text-primary font-bold">
          {label}{" "}
          <span className="text-gray-500 text-xl font-normal">{note}</span>
        </Heading>
      </div>
      {!!cta ? (
        <div className="mt-8 w-full">
          <Button
            className="w-full"
            variant={primary ? "primary" : "outline"}
            onPress={() =>
              onSelect({
                type: "single_choice",
                page: { type: "list_single_choice", id: questionId },
                data: { [id]: { id, label: heading, value } },
              })
            }
            isLoading={isLoading}
          >
            {cta}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default OptionBox;
